<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createFloodDiagram"
        v-if="hasPermission('create_flood_diagram')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Add Flood Diagram</span>
      </b-button>
    </div>

    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="site"
              label-for="site"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Building"
              label-for="building"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <v-select
                label="name"
                v-model="building"
                placeholder="Select Building"
                :options="buildings"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>


            <b-form-group
              label="Expiry Date"
              label-for="expiry_date"
              class="w-50"
              v-if="searchType.value === 3"
            >
              <b-form-datepicker id="expiry_date" v-model="expiry_date" class="mb-2"></b-form-datepicker>              
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="flood_diagrams"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_flood_diagram')"
        :per-page="0"
      >
        <template #cell(site_data)="row">
          {{
            row.item.site_data ? row.item.site_data.name : ""
          }}
        </template>

        <template #cell(building_data)="row">
          {{
            row.item.building_data ? row.item.building_data.name : ""
          }}
        </template>


        <template #cell(floor_data)="row">
          {{
            row.item.floor_data ? row.item.floor_data.floor_no : ""
          }}
        </template>

        
        <template #cell(manage)="row">
          <b-button
            variant="outline-success"
            pill
            size="sm"
            class="mr-50"
            @click="downloadImage(row.item.flood_diagram)"
            v-if="hasPermission('update_flood_diagram')"
          >
            Download
          </b-button>

          <b-button
            variant="outline-success"
            pill
            size="sm"
            class="mr-50"
            @click="editFloodDiagram(row.item)"
            v-if="hasPermission('update_flood_diagram')"
          >
            Edit
          </b-button>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <CreateFloodDiagramModal
      @modalClosed="onModalClosed"
      :key="`create-${createFloodDiagramModalCount}`"
    />
    <EditFloodDiagramModal
      :flood_diagram_data="flood_diagram_data"
      @modalClosed="onModalClosed"
      :key="`edit-${editFloodDiagramModalCount}`"
    />
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateFloodDiagramModal from "@/components/flood_diagram/CreateFloodDiagramModal.vue";
import EditFloodDiagramModal from "@/components/flood_diagram/EditFloodDiagramModal.vue";
import util from "@/util.js";


export default {
  components: {
    CreateFloodDiagramModal,
    EditFloodDiagramModal,
    VueSelectPaginated,
  },
  data() {
    return {
      fields: [
        { key: "site_data", label: "Site", thClass: "w-20", tdClass: "w-20" },
        { key: "building_data", label: "Building", thClass: "w-20", tdClass: "w-20" },
        { key: "floor_data", label: "Floor", thClass: "w-20", tdClass: "w-20" },
        { key: "installation_date", label: "Installation Date", thClass: "w-15", tdClass: "w-15" },
        { key: "expiry_date", label: "Expiry Date", thClass: "w-15", tdClass: "w-15" },
        { key: "manage", label: "Actions", thClass: "w-15", tdClass: "w-15" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      flood_diagrams: [],
      flood_diagram: null,
      flood_diagram_data: {},
      createFloodDiagramModalCount: 0,
      editFloodDiagramModalCount: 0,
      searchTypes: [
        { value: 1, name: "Site" },
        { value: 2, name: "Building" },
        { value: 3, name: "Expiry Date" },
      ],
      searchType: null,
      name: "",
      counts : "",
      sites: [],
      buildings: [],
      site : "",
      building : "",
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();

    const sites = await this.getSitesDDL();
    this.sites = sites.data;

    const buildings = await this.getBuildingsDDL();
    this.buildings = buildings.data;
  },
  methods: {
    ...mapActions({
      getFloodDiagrams: "appData/getFloodDiagrams",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getSitesDDL: "appData/getSitesDDL",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.building = "";
            this.expiry_date = "";
            break;
          case 2:
            this.site = "";
            this.expiry_date = "";
            break;          
          case 3:
            this.site = "";
            this.building = "";
            break;
          
        }
      } else {
          this.site = "";
          this.building = "";
          this.expiry_date = "";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getFloodDiagrams({
          pageNumber: this.currentPage,      
          site: this.site,      
          building: this.building,      
          expiry_date: this.expiry_date,      
        });
        this.flood_diagrams = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    downloadImage(imageUrl) {
      window.open(imageUrl, '_blank');
    },
    createFloodDiagram() {
      this.createFloodDiagramModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-flood-diagram-modal");
      });
    },
    editFloodDiagram(flood_diagram_data){
      this.flood_diagram_data=flood_diagram_data;
      this.$nextTick(() => {
        this.$bvModal.show("edit-flood-diagram-modal");
      });
    },
    
    async removeFloodDiagram(flood_diagram) {
      this.flood_diagram = flood_diagram;
      try {
        const res = await this.deleteFloodDiagram({
          pk: this.flood_diagram.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "Flood Diagram deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
